
import { defineComponent, PropType } from '@vue/runtime-core';
import { weaponOptions } from '../options';

export default defineComponent({
  name: 'WeaponSelect',
  props: {
    type: {
      type: String as PropType<TWeaponType>,
      required: true,
    },
  },
  methods: {
    onSelect(e: any) {
      console.log(this);
      const { value } = e;

      this.$emit('setWeapon', value);
    },
  },
  data() {
    return {
      weaponOptions,
    };
  },
});
